import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/icons/ic_chat_question.svg")